export { default } from "./AccordionDetails.mjs";
export { default as accordionDetailsClasses } from "./accordionDetailsClasses.mjs";
export * from "./accordionDetailsClasses.mjs";